import { render, staticRenderFns } from "./OpinionDefaultAdd.vue?vue&type=template&id=57454231&scoped=true"
import script from "./OpinionDefaultAdd.vue?vue&type=script&lang=js"
export * from "./OpinionDefaultAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57454231",
  null
  
)

export default component.exports